// LOCALES based on languages available in CLAAS ID
import { FullscreenOverlayContainer, OVERLAY_DEFAULT_CONFIG, OverlayContainer } from '@angular/cdk/overlay';
import { APP_BASE_HREF, CommonModule, registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeSouthafrican from '@angular/common/locales/af';
import localeEthiopia from '@angular/common/locales/am';
import localeUnitedArabEmirates from '@angular/common/locales/ar-AE';
import localeAlgeria from '@angular/common/locales/ar-DZ';
import localeEgypt from '@angular/common/locales/ar-EG';
import localeSaudiArabia from '@angular/common/locales/ar-SA';
import localeSudan from '@angular/common/locales/ar-SD';
import localeTunisia from '@angular/common/locales/ar-TN';
import localeTanzania from '@angular/common/locales/asa';
import localeAzerbaijani from '@angular/common/locales/az';
import localeZambia from '@angular/common/locales/bem';
import localeBulgarian from '@angular/common/locales/bg';
import localeBrazilian from '@angular/common/locales/br';
import localeBosnia from '@angular/common/locales/bs';
import localeCzech from '@angular/common/locales/cs';
import localeDanish from '@angular/common/locales/da';
import localeGerman from '@angular/common/locales/de';
import localeEbuKenya from '@angular/common/locales/ebu';
import localeGreek from '@angular/common/locales/el';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEnKenya from '@angular/common/locales/en-KE';
import localeNamibia from '@angular/common/locales/en-NA';
import localePakistan from '@angular/common/locales/en-PK';
import localeTrinidadTobago from '@angular/common/locales/en-TT';
import localeSpanish from '@angular/common/locales/es';
import localeBolivia from '@angular/common/locales/es-BO';
import localeChile from '@angular/common/locales/es-CL';
import localeColombia from '@angular/common/locales/es-CO';
import localeCostaRica from '@angular/common/locales/es-CR';
import localeDominicanRepublic from '@angular/common/locales/es-DO';
import localeEcuador from '@angular/common/locales/es-EC';
import localeHonduras from '@angular/common/locales/es-HN';
import localeMexican from '@angular/common/locales/es-MX';
import localeNicaragua from '@angular/common/locales/es-NI';
import localeEstonian from '@angular/common/locales/et';
import localeFinnish from '@angular/common/locales/fi';
import localeFrench from '@angular/common/locales/fr';
import localeReunion from '@angular/common/locales/fr-RE';
import localeSenegal from '@angular/common/locales/fr-SN';
import localeIsraeli from '@angular/common/locales/he';
import localeCroatian from '@angular/common/locales/hr';
import localeHungarian from '@angular/common/locales/hu';
import localeArmenia from '@angular/common/locales/hy';
import localeIcelandic from '@angular/common/locales/is';
import localeItalian from '@angular/common/locales/it';
import localeJapanese from '@angular/common/locales/ja';
import localeGeorgia from '@angular/common/locales/ka';
import localeKazakhstan from '@angular/common/locales/kk';
import localeCambodia from '@angular/common/locales/km';
import localeKorean from '@angular/common/locales/ko';
import localeKyrgyzstan from '@angular/common/locales/ky';
import localeLithuanian from '@angular/common/locales/lt';
import localeLatvian from '@angular/common/locales/lv';
import localeMacedonia from '@angular/common/locales/mk';
import localeMongolian from '@angular/common/locales/mn';
import localeMyanmar from '@angular/common/locales/my';
import localeNorway from '@angular/common/locales/nb'; // claas id returns 'no'
import localeDutch from '@angular/common/locales/nl';
import localePolish from '@angular/common/locales/pl';
import localePortuguese from '@angular/common/locales/pt';
import localeRomanian from '@angular/common/locales/ro';
import localeMoldovan from '@angular/common/locales/ro-MD';
import localeRussian from '@angular/common/locales/ru';
import localeSlovak from '@angular/common/locales/sk';
import localeSlovenia from '@angular/common/locales/sl';
import localeSerbian from '@angular/common/locales/sr';
import localeSwedish from '@angular/common/locales/sv';
import localeTajikistan from '@angular/common/locales/tg';
import localeThai from '@angular/common/locales/th';
import localeTurkmenistan from '@angular/common/locales/tk';
import localeTurkish from '@angular/common/locales/tr';
import localeUkrainian from '@angular/common/locales/uk';
import localeUsbek from '@angular/common/locales/uz';
import localeVietnamese from '@angular/common/locales/vi';
import localeChinese from '@angular/common/locales/zh';
import { APP_ID, effect, enableProdMode, importProvidersFrom, inject } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ApiPartnerEnum, RDV_LIB_CONFIG, RdvTranslateLoader } from '@claas-rdv/rdv-client';
import { setOptions } from '@googlemaps/js-api-loader';
import { Store } from '@ngrx/store';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { CdeFeConvertPipeModule, ConvertPipeStore, TRANSLATE_SERVICE } from 'cde-fe-convert-pipe';
import { CdeFeOrganizationRegistrationDialogModule } from 'cde-fe-organization-registration-dialog';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_ROUTES } from '@cde-fe-app/app/app-routing';
import { AppComponent } from '@cde-fe-app/app/app.component';
import { CdeToastComponent } from '@cde-fe-app/app/cde-toast/components/cde-toast/cde-toast.component';
import { UrlWithProtocolPipe } from '@cde-fe-app/app/custom-pipes/pipe/url-with-protocol';
import { CoreModule } from '@cde-fe-app/app/shared/core.module';
import { AlarmService } from '@cde-fe-app/app/shared/services/alarm.service';
import { AnalyticsService } from '@cde-fe-app/app/shared/services/analytics.service';
import { AuthServiceWrapper } from '@cde-fe-app/app/shared/services/auth.service';
import { DashboardService } from '@cde-fe-app/app/shared/services/dashboard.service';
import { EquipmentRemoteService } from '@cde-fe-app/app/shared/services/equipment-remote.service';
import { FileTransferService } from '@cde-fe-app/app/shared/services/file-transfer.service';
import { InterceptorService } from '@cde-fe-app/app/shared/services/interceptor.service';
import { LicenseService } from '@cde-fe-app/app/shared/services/license.service';
import { MachinesService } from '@cde-fe-app/app/shared/services/machines.service';
import { NotificationsService } from '@cde-fe-app/app/shared/services/notifications.service';
import { RoutingStateService } from '@cde-fe-app/app/shared/services/routing-state.service';
import { ServiceCall } from '@cde-fe-app/app/shared/services/service-call.service';
import { SupportService } from '@cde-fe-app/app/shared/services/support.service';
import { UserService } from '@cde-fe-app/app/shared/services/user.service';
import * as AuthSelectors from '@cde-fe-app/app/shared/state/auth/index';
import { dealerStore } from '@cde-fe-app/app/shared/state/dealer/dealer.store';
import * as RootState from '@cde-fe-app/app/shared/state/index';
import { cmpCountries } from '@cde-fe-app/app/shared/utils/cmp.countries-source';
import { LocalizedPaginator } from '@cde-fe-app/app/shared/utils/localized-paginator';
import { marketingFootnotes } from '@cde-fe-app/app/shared/utils/mp-footnote-source';
import { environment } from '@cde-fe-app/environments/environment';
import { bearerToken$, dealerLocatorRequestConfig, safeSubjectNext } from './page-components.config';

registerLocaleData(localeCroatian);
registerLocaleData(localeCzech);
registerLocaleData(localeDanish);
registerLocaleData(localeDutch);
registerLocaleData(localeEnGb);
registerLocaleData(localeEstonian);
registerLocaleData(localeFinnish);
registerLocaleData(localeFrench);
registerLocaleData(localeGerman);
registerLocaleData(localeItalian);
registerLocaleData(localeLatvian);
registerLocaleData(localeLithuanian);
registerLocaleData(localeNorway);
registerLocaleData(localePolish);
registerLocaleData(localePortuguese);
registerLocaleData(localeRomanian);
registerLocaleData(localeRussian);
registerLocaleData(localeSlovak);
registerLocaleData(localeSlovenia);
registerLocaleData(localeSpanish);
registerLocaleData(localeSwedish);
registerLocaleData(localeUkrainian);
registerLocaleData(localeHungarian);
registerLocaleData(localeKazakhstan);
registerLocaleData(localeSouthafrican);
registerLocaleData(localeAzerbaijani);
registerLocaleData(localeBrazilian);
registerLocaleData(localeMexican);
registerLocaleData(localeMoldovan);
registerLocaleData(localeSerbian);
registerLocaleData(localeBulgarian);
registerLocaleData(localeUsbek);
registerLocaleData(localeGreek);
registerLocaleData(localeIsraeli);
registerLocaleData(localeJapanese);
registerLocaleData(localeTurkish);
registerLocaleData(localeVietnamese);
registerLocaleData(localeIcelandic);
registerLocaleData(localeEnKenya);
registerLocaleData(localeEbuKenya);
registerLocaleData(localeEgypt);
registerLocaleData(localeKyrgyzstan);
registerLocaleData(localeChile);
registerLocaleData(localeEthiopia);
registerLocaleData(localeUnitedArabEmirates);
registerLocaleData(localeAlgeria);
registerLocaleData(localeSaudiArabia);
registerLocaleData(localeSudan);
registerLocaleData(localeTunisia);
registerLocaleData(localeTanzania);
registerLocaleData(localeZambia);
registerLocaleData(localeBosnia);
registerLocaleData(localeNamibia);
registerLocaleData(localePakistan);
registerLocaleData(localeTrinidadTobago);
registerLocaleData(localeBolivia);
registerLocaleData(localeColombia);
registerLocaleData(localeCostaRica);
registerLocaleData(localeDominicanRepublic);
registerLocaleData(localeEcuador);
registerLocaleData(localeHonduras);
registerLocaleData(localeNicaragua);
registerLocaleData(localeReunion);
registerLocaleData(localeSenegal);
registerLocaleData(localeArmenia);
registerLocaleData(localeGeorgia);
registerLocaleData(localeCambodia);
registerLocaleData(localeKorean);
registerLocaleData(localeMacedonia);
registerLocaleData(localeMongolian);
registerLocaleData(localeMyanmar);
registerLocaleData(localeTajikistan);
registerLocaleData(localeThai);
registerLocaleData(localeTurkmenistan);
registerLocaleData(localeChinese);

/**
 * Simple HTTP loader for translations from a remote URL
 */
class HttpTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string,
    private suffix: string
  ) {}

  getTranslation(lang: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.http.get<Record<string, any>>(`${this.prefix}${lang}${this.suffix}`);
  }
}

/**
 * Custom TranslateLoader that merges the app's HTTP-loaded translations
 * with the RDV library's inline translations.
 *
 * This is necessary because ngx-translate's loadAndCompileTranslations()
 * overwrites the entire translations object for a language (when extend=false),
 * which discards any translations previously merged via setTranslation().
 * The RDV library's provideRdvClient() merges its translations in an
 * APP_INITIALIZER and subscribes to onTranslationChange for re-merging,
 * but loadAndCompileTranslations does NOT emit onTranslationChange —
 * it only emits onDefaultLangChange or onLangChange. So the RDV translations
 * are lost after the HTTP loader finishes.
 *
 * By combining both loaders here, the RDV translations are included in
 * every load cycle and can never be overwritten.
 */
class CombinedTranslateLoader implements TranslateLoader {
  private httpLoader: HttpTranslateLoader;
  private rdvLoader = new RdvTranslateLoader();

  constructor(httpBackend: HttpBackend) {
    const http = new HttpClient(httpBackend);
    this.httpLoader = new HttpTranslateLoader(http, environment.translationBaseUrl, '.json');
  }

  getTranslation(lang: string) {
    return forkJoin([this.httpLoader.getTranslation(lang), this.rdvLoader.getTranslation(lang)]).pipe(
      map(
        ([appTranslations, rdvTranslations]) =>
          ({
            ...appTranslations,
            ...rdvTranslations,
          }) as Record<string, never>
      )
    );
  }
}

// used for Moment Date Adapter to ensure 2-digit dates
const dateFormats = {
  parse: {
    dateInput: 'L',
    timeInput: 'LT',
  },
  display: {
    dateInput: 'L',
    timeInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    timeOptionLabel: 'LT',
  },
};

let lastBearerToken = '';
let lastDealerLocatorConfig = {
  country: 'de',
  language: 'en-gb',
};

const PROVIDERS = [
  // SERVICES
  AlarmService,
  AnalyticsService,
  AuthServiceWrapper,
  DashboardService,
  EquipmentRemoteService,
  FileTransferService,
  MachinesService,
  NotificationsService,
  LicenseService,
  ServiceCall,
  SupportService,
  UserService,
  RoutingStateService,
  { provide: localeCroatian, useValue: 'hr' },
  { provide: localeCzech, useValue: 'cs' },
  { provide: localeDanish, useValue: 'da' },
  { provide: localeDutch, useValue: 'nl' },
  { provide: localeEnGb, useValue: 'en-GB' },
  { provide: localeEstonian, useValue: 'et' },
  { provide: localeFinnish, useValue: 'fi' },
  { provide: localeFrench, useValue: 'fr' },
  { provide: localeGerman, useValue: 'de' },
  { provide: localeItalian, useValue: 'it' },
  { provide: localeLatvian, useValue: 'lv' },
  { provide: localeLithuanian, useValue: 'lt' },
  { provide: localeNorway, useValue: 'no' },
  { provide: localePolish, useValue: 'pl' },
  { provide: localePortuguese, useValue: 'pt' },
  { provide: localeRomanian, useValue: 'ro' },
  { provide: localeRussian, useValue: 'ru' },
  { provide: localeSlovak, useValue: 'sk' },
  { provide: localeSlovak, useValue: 'sl' },
  { provide: localeSpanish, useValue: 'es' },
  { provide: localeSwedish, useValue: 'sv' },
  { provide: localeUkrainian, useValue: 'uk' },
  { provide: localeHungarian, useValue: 'hu' },
  { provide: localeSouthafrican, useValue: 'af' },
  { provide: localeAzerbaijani, useValue: 'az' },
  { provide: localeBrazilian, useValue: 'br' },
  { provide: localeMexican, useValue: 'es-MX' },
  { provide: localeKazakhstan, useValue: 'kk' },
  { provide: localeMoldovan, useValue: 'ro-MD' },
  { provide: localeSerbian, useValue: 'sr' },
  { provide: localeBulgarian, useValue: 'bg' },
  { provide: localeUsbek, useValue: 'uz' },
  { provide: localeGreek, useValue: 'el' },
  { provide: localeIsraeli, useValue: 'he' },
  { provide: localeJapanese, useValue: 'ja' },
  { provide: localeTurkish, useValue: 'tr' },
  { provide: localeVietnamese, useValue: 'vi' },
  { provide: localeIcelandic, useValue: 'is' },
  { provide: localeEnKenya, useValue: 'en-KE' },
  { provide: localeEbuKenya, useValue: 'ebu' },
  { provide: localeEgypt, useValue: 'ar-EG' },
  { provide: localeKyrgyzstan, useValue: 'ky' },
  { provide: localeChile, useValue: 'es-CL' },
  { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
  { provide: TRANSLATE_SERVICE, useClass: TranslateService },
  { provide: MatPaginatorIntl, useClass: LocalizedPaginator },
  { provide: APP_ID, useValue: 'serverApp' },
  { provide: APP_BASE_HREF, useValue: '/' },
  ConvertPipeStore,
  UrlWithProtocolPipe,
  // avoid warning NG02813 by enabling the Fetch API
  provideHttpClient(withFetch(), withInterceptorsFromDi()),
  MatIconRegistry,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true,
  },
  { provide: TRANSLATE_SERVICE, useExisting: TranslateService },
  provideMomentDateAdapter(dateFormats),
  provideAnimations(),
  provideRouter(APP_ROUTES),
  provideCharts(withDefaultRegisterables()),
  {
    provide: RDV_LIB_CONFIG,
    useFactory: (translate: TranslateService) => ({
      partnerSystem: ApiPartnerEnum.CC3,
      apiBaseUrl: environment.apiBaseUrl,
      language: deriveUserLanguage(translate.getCurrentLang() ?? translate.getFallbackLang()),
      standaloneUrl: environment.rdvBaseUrl,
    }),
    deps: [TranslateService],
  },
  {
    provide: OVERLAY_DEFAULT_CONFIG,
    useValue: { usePopover: false },
  },
];

if (environment.production) {
  enableProdMode();
}

function deriveUserLanguage(lang?: string): string {
  if (!lang) return 'en';
  return lang.split('-')[0].toLowerCase();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      CommonModule,
      TranslateModule.forRoot({
        defaultLanguage: 'en-gb',
        loader: {
          provide: TranslateLoader,
          useFactory: (httpBackend: HttpBackend) => new CombinedTranslateLoader(httpBackend),
          deps: [HttpBackend],
        },
      }),
      BrowserModule,
      CoreModule,
      CdeFeConvertPipeModule.forRoot({}),
      CdeFeOrganizationRegistrationDialogModule.forRoot(
        environment.claasIdUserApiBaseUrl,
        environment.claasIdApiBaseUrl,
        environment.apiBaseUrl,
        environment.allowedLanguages,
        marketingFootnotes,
        cmpCountries,
        {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          get dealerStore(): any {
            return inject(dealerStore);
          },
          bearerToken$,
          dealerLocatorRequestConfig,
        }
      ),
      MatNativeDateModule,
      ToastrModule.forRoot({
        toastComponent: CdeToastComponent,
        preventDuplicates: false,
        maxOpened: 3,
        titleClass: 'cde-toast-title',
        messageClass: 'cde-toast-message',
      })
    ),
    PROVIDERS,
  ],
})
  .then(appRef => {
    const ngrxStore = appRef.injector.get<Store<RootState.IState>>(Store);
    const user = ngrxStore.selectSignal(AuthSelectors.userSelector);
    const token = ngrxStore.selectSignal(AuthSelectors.getTokenSelector);
    setOptions({ key: environment.googleMapsAPIKey });

    effect(
      () => {
        // Setup setting dealer locator config from user store
        const userValue = user();
        if (userValue) {
          const nextCountry = userValue.user_metadata?.country ?? 'de';
          const nextLanguage = userValue.user_metadata?.language ?? 'en-gb';
          if (nextCountry !== lastDealerLocatorConfig.country || nextLanguage !== lastDealerLocatorConfig.language) {
            lastDealerLocatorConfig = {
              country: nextCountry,
              language: nextLanguage,
            };
            safeSubjectNext(
              dealerLocatorRequestConfig,
              {
                country: nextCountry,
                language: nextLanguage,
                noGeoCodedCountriesList: environment.noGeoCodedCountriesList,
              },
              'dealer locator config'
            );
          }
        }
        const nextToken = token() ?? '';
        if (nextToken !== lastBearerToken) {
          lastBearerToken = nextToken;
          safeSubjectNext(bearerToken$, nextToken, 'bearer token');
        }
      },
      { injector: appRef.injector }
    );
  })
  .catch(err => console.error(err));
